'use strict';

var NavSoftScroll = require('../../main-nav/lib/nav-soft-scroll');

var Navs = function(config) {
  var self = this;
  var $item = $(config.item);
  var $children = $(config.children);
  var $megamenu = $(config.megamenu);
  var $megamenuItem = $(config.megamenuItem);
  var containerTemplate = config.containerTemplate;

  self.checkCurrContainers = function(slug) {
    var canCreateContainer = true;
    var $currMegamenuItems = $megamenu.find($megamenuItem);

    if ($currMegamenuItems.length) {
      $currMegamenuItems.each(function() {
        var $this = $(this);
        var currSlug = $this.attr('data-menu-item-slug');

        if (currSlug === slug) {
          canCreateContainer = false;
          return false;
        }
      });
    }

    return canCreateContainer;
  }

  self.parseItems = function() {
    $item.each(function() {
      var $this = $(this);

      if ($this[0].hasAttribute('id')) {
        var slug = $this.attr('id').match(/\d+/)[0]; // Get digits from wp generated id: #menu-item-40
        var canCreateContainer = self.checkCurrContainers(slug);
        var _$children = $this.find($children).clone();

        if (_$children.length && canCreateContainer) {
          self.removeIdAttrs(_$children, slug);
        }
      }
    });
  }

  self.removeIdAttrs = function(_$children, slug) {
    _$children.each(function() {
      var $this = $(this);
      var _$li = $this.find('li');
      _$li.removeAttr('id');
    });
    self.appendContainer(_$children, slug);
  }

  self.newContainer = function(_slug) {
    var content = {
      slug: _slug
    };
    var _container = _.template(containerTemplate);
    return $(_container({content: content}));
  }

  self.appendContainer = function(_$children, _slug) {
    var _$container = self.newContainer(_slug);
    _$container.append(_$children);
    $megamenu.append(_$container);
    new NavSoftScroll({
      nav: config.megamenu
    }).init();
  }

  self.init = function() {
    self.parseItems();
  }
};

module.exports = Navs;
